import { useEffect, useState, useRef, useMemo, useContext, useCallback } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import NavBar from "../layout/NavBar";
import { toast } from "react-toastify";
import { http } from "../auth";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { MdArrowForwardIos, MdLock, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { Link } from "react-router-dom";
import { PiBankDuotone } from "react-icons/pi";
import { TbDeviceMobileDollar, TbPasswordUser, TbPigMoney } from "react-icons/tb";
import bdv from "../static/img/bdv_banner.png";
import bill from "../static/img/bill.png";
import { IoDocumentText, IoEye } from "react-icons/io5";
import Billimg from "../components/Billimg";
import Bill from "../components/Bill";
import { useLocation } from "react-router-dom";
import Abonar from "../components/Abonar";
import { IoMdUnlock } from "react-icons/io";
import { FaCog } from "react-icons/fa";
import PagoC2P from "../components/PagoC2P";
import venezuela from "../static/img/venezuela.png";
import { useNavigate } from "react-router-dom";
import PagoP2P from "../components/PagoP2P";
import BdvIpg from "../components/BdvIpg";
import Reporte1 from "../components/Reporte1";
import { useThemeManager } from "../Hooks/ThemeManager";


const Metodos = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [fact, setFact] = useState(true);
  const numeroDeFacturas = localStorage.getItem("numeroDeFacturas");
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedMetodo, setSelectedMetodo] = useState(null);
  const [transferencia, setTransferencia] = useState(false);
  const [idServicio, setIdServicio] = useState([]);
  const [abonarData, setAbonarData] = useState(null);
  const [activate, setActivate] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [loadResume, setLoadResume] = useState(true);
  const [nameMetodo, setNameMetodo] = useState({
    name: null,
    icon: null,
  });
  const { themeColors } = useThemeManager();
  const [configuracionMetodos, setConfiguracionMetodos] = useState([]);
  const [pasoTransferencia, setPasoTransferencia] = useState(1);
  const [tasa, setTasa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState("bs");
  const [totalAPagar, setTotalAPagar] = useState("0");
  const [totalAPagarLoading, setTotalAPagarLoading] = useState(false);


  const handleAbonarChange = (data) => {
    setAbonarData(data);
  };

  const handleTotalChange = (total) => {
    setTotalAPagar(total || "0");
    setTotalAPagarLoading(false);
  };

  const handleBankChange = useCallback((bankName) => {
    setSelectedBank(bankName);
  }, []);

  const handleSelectMetodo = (ruta) => {
    setSelectedBank("");
    setTotalAPagarLoading(true);
    switch (ruta) {
      case "c2p":
        setSelectedMetodo("c2p");
        setTransferencia(false);
        setNameMetodo({
          name: "Pago C2P",
          icon: <TbPasswordUser className="iconc2p" />,
        });
        break;
      case "p2p":
        setSelectedMetodo("p2p");
        setTransferencia(false);
        setNameMetodo({
          name: "Pago Móvil",
          icon: <TbDeviceMobileDollar className="iconc2p" />,
        });
        break;
      case "ipg":
        setSelectedMetodo("ipg");
        setTransferencia(false);
        setNameMetodo({
          name: "Pago BDV",
          icon: <img src={venezuela} className="bdv-simple" alt="logo Banco de Venezuela" />,
        });
        break;
      case "transferencia":
        setSelectedMetodo("transferencia");
        setTransferencia(true);
        setPasoTransferencia(1);
        setNameMetodo({
          name: "Transferencia Bancaria",
          icon: <PiBankDuotone className="icon-bank" />,
        });
        break;
      default:
        setSelectedMetodo(null);
        setTransferencia(false);
    }
  };

  const handleSelectedIdsChange = (updatedIds) => {
    setSelectedIds(updatedIds);
    setIdServicio(updatedIds);
  };

  const abonar = location.state?.abonar;
  const factura = location?.state?.factura;


  useEffect(() => {
    if (abonar) {
      setFact(false);
      setNameMetodo({
        name: "Abonar",
        icon: <TbPigMoney className="iconc2p" />,
      });
    }
  }, []);

  useEffect(() => {
    const initData = async () => {
      try {
        const [configRes, metodosRes] = await Promise.all([
          http.get("/config/estado_medios_online"),
          http.get("/intranet-j/metodos-pago", {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setConfiguracionMetodos(configRes.data);
        setActivate(configRes.data);

        setData(metodosRes.data);
        setData2(metodosRes.data?.facturas || []);
        setTasa(metodosRes.data.tasa);
        const nFac = metodosRes.data?.facturas?.length;
        const idsFac = metodosRes.data?.facturas?.map((f) => f.id) || [];
        localStorage.setItem("numeroDeFacturas", nFac);
        localStorage.setItem("idsFacturas", JSON.stringify(idsFac));
      } catch (error) {
        if (error?.response && ![200, 401].includes(error?.response?.status)) {
          toast.error("Ocurrio un error al cargar los medios online");
        }
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    initData();
  }, [token]);

  const handleBack = () => {
    if (selectedMetodo === "transferencia" && pasoTransferencia === 2) {
      setPasoTransferencia(1);
      setTransferencia(true);
    } else {
      setSelectedMetodo(null);
      setPasoTransferencia(1);
      setTransferencia(false);
    }


    if (selectedMetodo === null) {
      navigate("/pagos");
    }

    if (abonar) {
      setNameMetodo({
        name: "Abonar",
        icon: <TbPigMoney className="iconc2p" />,
      });
    } else {
      setNameMetodo({
        name: null,
        icon: null,
      });
    }
  };


  const metodoHabilitado = (tipo) => {
    // Transferencias bancarias siempre disponibles
    if (tipo === "transferencia") return true;

    // Para IPG - Buscar en bank_settings con propiedad 'ipg'
    if (tipo === "ipg") {
      return configuracionMetodos.some((item) => item.config_type === "bank_settings" && item.ipg?.enabled_j === true);
    }

    // Para C2P y P2P, buscar en bank_settings
    if (tipo === "c2p" || tipo === "p2p") {
      return configuracionMetodos.some(
        (item) => item.config_type === "bank_settings" && item[tipo]?.enabled_j === true,
      );
    }

    return false;
  };
  // Filtrar métodos según configuración
  const metodosDisponibles = useMemo(() => {
    const metodosBase = [
      {
        id: 1,
        icon: <TbPasswordUser className="iconDetails" />,
        titulo: "Pago C2P",
        descripcion: "Genera tu token y paga de inmediato",
        ruta: "c2p",
        border: "top",
      },
      {
        id: 2,
        icon: <TbDeviceMobileDollar className="iconDetails" />,
        titulo: "Pago Móvil",
        descripcion: "Realiza el pago y reporta tu transacción",
        ruta: "p2p",
        border: "not-border",
        list: selectedIds,
      },
      {
        id: 3,
        imagen: bdv,
        ruta: "ipg",
        border: "not-border",
      },
      {
        id: 4,
        icon: <PiBankDuotone className="iconDetails color-secondary" />,
        titulo: "Transferencias bancarias",
        descripcion: "Reporta tu pago y espera por su verificación",
        ruta: "transferencia",
        border: "bottom",
      },
    ];

    // Filtrar solo los métodos habilitados
    return metodosBase.filter((metodo) => metodoHabilitado(metodo.ruta));
  }, [configuracionMetodos, selectedIds, themeColors]);

  return (
    <div>
      <div className="header-pago">
        <div className="back cursor color-primary" onClick={handleBack}>
          <div>
            <MdOutlineKeyboardArrowLeft className="btn-back" />
          </div>
          <div>
            <span>Volver</span>
          </div>
        </div>
        <div className="titulo-medio">
          {nameMetodo.icon} {nameMetodo.name}
        </div>
      </div>
      <div className="containerPagos">
        <div className="pagosContainer">
          <div>
            {(factura || fact) && (
              <>
                <div
                  className="d-flex flex-row justify-content-between column-gap-5 color-secondary"
                >
                  <div>
                    <span className="tituloRealizar">Pagar </span>
                    {selectedMetodo === null && (
                      <span className="description">
                        Usted posee {numeroDeFacturas} {numeroDeFacturas === 1 ? "documento" : "documentos"} pendiente
                        {numeroDeFacturas === 1 ? "" : "s"} por pagar
                      </span>
                    )}
                  </div>
                  <div>
                    {loading ? (
                      <div className="placeholder-glow">
                        <div className="placeholder col-8" style={{ height: 16 }}></div>
                      </div>
                    ) : (
                      <span className="fs-6">
                        <strong>Tasa:</strong> {data?.tasa} Bs.
                      </span>
                    )}
                  </div>
                </div>

                {loading ? (
                  <div className="placeholder-glow">
                    <div className="border rounded p-3 mb-2" style={{ background: "#f5f5f5" }}>
                      <div className="placeholder col-6 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-9 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-7 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-5" style={{ height: 14 }}></div>
                    </div>
                    <div className="border rounded p-3" style={{ background: "#f5f5f5" }}>
                      <div className="placeholder col-6 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-9 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-7 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-5" style={{ height: 14 }}></div>
                    </div>
                  </div>
                ) : (
                  <>
                    <Bill
                      themeColors={themeColors}
                      disabled={selectedMetodo !== null}
                      type={selectedMetodo}
                      onSelectedIdsChange={handleSelectedIdsChange}
                      show={transferencia}
                      selectedMetodo={selectedMetodo}
                      selectedBank={selectedBank}
                      data={data2}
                      loading={loading}
                      selectedCurrency={selectedCurrency}
                      onTotalChange={handleTotalChange}
                    />
                  </>
                )}
            </>
            )}
            {abonar && (
              <>
                {loading ? (
                  <div className="placeholder-glow">
                    <div className="border rounded p-3" style={{ background: "#f5f5f5" }}>
                      <div className="placeholder col-6 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-9 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-4 mb-2" style={{ height: 14 }}></div>
                      <div className="placeholder col-7" style={{ height: 14 }}></div>
                    </div>
                  </div>
                ) : (
                  <Abonar
                    disabled={selectedMetodo !== null}
                    type={selectedMetodo}
                    onSelectedIdsChange={handleSelectedIdsChange}
                    show={transferencia}
                    onAbonarChange={handleAbonarChange}
                    selectedMetodo={selectedMetodo}
                    setSelectedMetodo={setSelectedMetodo}
                    selectedBank={selectedBank}
                    data={data}
                    tasa={tasa}
                    loading={loading}
                    selectedCurrency={selectedCurrency}
                    onTotalChange={handleTotalChange}
                  />
                )}
              </>
            )}
          </div>

          {selectedMetodo === null && (
            <div>
              <span className="tituloRealizar text-center-block mt-5 color-secondary">
                Métodos de pagos
              </span>
              <span className="description text-center-block mb-3">Selecciona el de tu preferencia</span>

              {loading ? (
                <div className="placeholder-glow">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="formasBorder d-flex align-items-center p-3 mb-2" style={{ gap: 12 }}>
                      <div
                        className="placeholder rounded-circle flex-shrink-0"
                        style={{ width: 40, height: 40 }}
                      ></div>
                      <div className="flex-grow-1">
                        <div className="placeholder col-4 mb-1" style={{ height: 14 }}></div>
                        <div className="placeholder col-7" style={{ height: 12 }}></div>
                      </div>
                      <div className="placeholder flex-shrink-0" style={{ width: 20, height: 20 }}></div>
                    </div>
                  ))}
                </div>
              ) : (
                metodosDisponibles.length === 0 ? (
                  <div className="text-center p-4">
                    <p>No hay métodos de pago disponibles en este momento</p>
                  </div>
                ) : (
                  metodosDisponibles?.map((tarjeta) => (
                    <div
                      key={tarjeta.id}
                      className={`formasBorder ${tarjeta.border}`}
                      onClick={() => {
                        if (selectedIds?.length === 0) {
                          toast.warning("Seleccione un documento a pagar");
                          return;
                        }
                        handleSelectMetodo(tarjeta.ruta);
                      }}
                    >
                      <Row className="formasPago">
                        {tarjeta.imagen ? (
                          <>
                            <Col xs={10} className="col-imagen">
                              <img src={tarjeta.imagen} alt="BDV Banner" className="bdv-banner ms-sm-3" />
                            </Col>
                            <Col xs={2} className="iconPago">
                              <MdArrowForwardIos className="iconPago-size" />
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col xs={10} className="col-metodo-2">
                              <div className="ms-sm-4 me-sm-3 me-3">{tarjeta.icon}</div>
                              <div className="col-metodo">
                                <span className="titulo-pago color-secondary">
                                  {tarjeta.titulo}
                                </span>
                                <span className="description">{tarjeta.descripcion}</span>
                              </div>
                            </Col>
                            <Col xs={2} className="iconPago">
                              <MdArrowForwardIos className="iconPago-size" />
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                  ))
                )
              )}
            </div>
          )}

          {selectedMetodo === "c2p" && (
            <PagoC2P
              themeColors={themeColors}
              id_doc={selectedIds}
              id_servicio={idServicio}
              factura={fact}
              resumen={abonarData}
              onBankChange={handleBankChange}
              loadResume={loadResume}
            />
          )}

          {selectedMetodo === "p2p" && (
            <PagoP2P
              id_doc={selectedIds}
              id_servicio={idServicio}
              factura={fact}
              resumen={abonarData}
              onBankChange={handleBankChange}
              totalAPagar={totalAPagar}
              totalAPagarLoading={totalAPagarLoading}
            />
          )}

          {selectedMetodo === "ipg" && (
            <BdvIpg
              id_doc={selectedIds}
              id_servicio={idServicio}
              factura={fact}
              abonar={abonar}
              resumen={abonarData}
              onBankChange={handleBankChange}
              
            />
          )}

          {selectedMetodo === "transferencia" && (
            <Reporte1
              transferencia={transferencia}
              setTransferencia={setTransferencia}
              id_doc={selectedIds}
              id_servicio={idServicio}
              factura={fact}
              resumen={abonarData}
              onBankChange={handleBankChange}
              pasoActual={pasoTransferencia}
              setPasoActual={setPasoTransferencia}
              selectedCurrency={selectedCurrency}
              setSelectedCurrency={setSelectedCurrency}
              loadResume={loadResume}
              totalAPagar={totalAPagar}
              totalAPagarLoading={totalAPagarLoading}
            />
          )}
        </div>

        <div className="side-image mt-lg-5 mt-xl-0">
          {loading ? (
            <div className="placeholder-glow">
              <div
                className="placeholder"
                style={{ width: 250, height: 300, borderRadius: 12 }}
              ></div>
            </div>
          ) : (
            <Billimg themeColors={themeColors} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Metodos;
